namespace TabAurous.Retail {
    export interface ReceiptRow {
        TransId?: number;
        VoucherNo?: string;
        InvoiceNo?: string;
        SuffixPrefixId?: number;
        Date?: string;
        RefNo?: string;
        RefDate?: string;
        EnteredBy?: string;
        LedgerId?: number;
        POSCustomerId?: number;
        LedgerName?: string;
        PosCustomerCode?: string;
        IsAdvance?: boolean;
        TotalAmount?: number;
        Narration?: string;
        VoucherTypeId?: number;
        RefTransId?: number;
        RefVoucherId?: number;
        UserId?: number;
        Username?: string;
        FinancialYearId?: number;
        CurrencyId?: number;
        ExchangeRate?: number;
        CompanyId?: number;
        TaxLedgerId?: number;
        KnockOffTotal?: number;
        ReceiptDetails?: ReceiptDetailsRow[];
        PartyBalance?: Finance.PartyBalanceRow[];
        OrderVoucherNo?: string;
        RefVoucherNo?: string;
        BankId?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace ReceiptRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.Receipt';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherNo = "VoucherNo",
            InvoiceNo = "InvoiceNo",
            SuffixPrefixId = "SuffixPrefixId",
            Date = "Date",
            RefNo = "RefNo",
            RefDate = "RefDate",
            EnteredBy = "EnteredBy",
            LedgerId = "LedgerId",
            POSCustomerId = "POSCustomerId",
            LedgerName = "LedgerName",
            PosCustomerCode = "PosCustomerCode",
            IsAdvance = "IsAdvance",
            TotalAmount = "TotalAmount",
            Narration = "Narration",
            VoucherTypeId = "VoucherTypeId",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            UserId = "UserId",
            Username = "Username",
            FinancialYearId = "FinancialYearId",
            CurrencyId = "CurrencyId",
            ExchangeRate = "ExchangeRate",
            CompanyId = "CompanyId",
            TaxLedgerId = "TaxLedgerId",
            KnockOffTotal = "KnockOffTotal",
            ReceiptDetails = "ReceiptDetails",
            PartyBalance = "PartyBalance",
            OrderVoucherNo = "OrderVoucherNo",
            RefVoucherNo = "RefVoucherNo",
            BankId = "BankId",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
